import React from 'react'
import { getPartyColor } from 'swiss-party-colors'
import styles from './partyChart.module.scss'
import { useTransition, animated as a } from 'react-spring'

const VIEWBOX_HEIGHT = 100
const RECT_WIDTH = 10
const MIN_HEIGHT_MULTIPLICATOR = 0.03

interface Props {
  distribution: { [key: string]: number }
}

// We're not using not lib/parties.yml here, so we can use our
// own order (by colour), and so we are not dependent on the locale (since we
// are by default using the German abbreviations).
const parties = ['SP', 'CVP', 'BDP', 'GLP', 'GPS', 'SVP', 'FDP']

export function PartyChart({ distribution }: Props) {
  // Calculate largest number
  const max = Object.values(distribution).reduce(
    (previousValue, currentValue) => {
      if (currentValue >= previousValue) return currentValue

      return previousValue
    },
    1
  )

  const transitions = useTransition(
    parties.map(party => ({
      key: party,
      y: distribution[party] / max || 0,
      height: distribution[party] / max || 0
    })),
    item => item.key,
    {
      from: { y: 0, height: 0 },
      update: ({ y, height }) => ({ y, height }),
      config: {
        mass: 3,
        tension: 300,
        friction: 10
      },
      trail: 100,
      unique: true
    }
  )

  return (
    <svg
      className={styles.partyChart}
      viewBox={`0 0 ${RECT_WIDTH * parties.length} ${VIEWBOX_HEIGHT} `}
      preserveAspectRatio='none'
    >
      {transitions.map(({ item, props }, index) => {
        return (
          <a.rect
            key={item.key}
            width={RECT_WIDTH}
            x={index * RECT_WIDTH}
            fill={getPartyColor('de', item.key)}
            y={props.y.interpolate({
              output: [
                VIEWBOX_HEIGHT - VIEWBOX_HEIGHT * MIN_HEIGHT_MULTIPLICATOR,
                0
              ]
            })}
            height={props.height.interpolate({
              extrapolateLeft: 'clamp',
              output: [
                VIEWBOX_HEIGHT * MIN_HEIGHT_MULTIPLICATOR,
                VIEWBOX_HEIGHT
              ]
            })}
          />
        )
      })}
    </svg>
  )
}
